/* global $:true Foundation:true */
import debug from "debug";
import plugin from "../../lib/plugin";
import { tmpl } from "../../lib/strings";
import { GAServices } from "../../services/ga-services";
import { KlaviyoServices } from "../../services/klaviyo-services";

const MODULE_NAME = "app.core/modules/cart";
const log = debug(MODULE_NAME);
const ELEMENT_SELECTOR = "[data-add-to-cart]";
const PROGRESS_CLASS = "is-submitting";
const SUCCESS_CLASS = "is-submitted";
const PRODUCT_ID_ATTR = "data-product-id";
const PRICE_ATTR = "data-price";
const HIDE_CLASS = "u-hide";
const ERROR_CONTAINER_SELECTOR = "[data-add-to-cart-error-message]";

//  todo pull these from CMS editable page somehow
const validationMessages = {
	// empty: 'What quantity would you like quoted?',
	// min: 'What quantity would you like quoted?',
	// max: 'Sorry you can’t order more than {{max}}',
	integer:
		$(`meta[name="site.addToCartValidation.integer"]`).attr("content") ||
		"Oops! Enter the number as digits only please.",
	connection:
		$(`meta[name="site.addToCartValidation.connection"]`).attr("content") ||
		"An error occurred sending your request to the server. Please try again later.",
};

const quantityTests = [
	// {
	//     //  is not empty
	//     test: value => value !== '',
	//     message: 'empty'
	// },
	{
		// is integer
		test: (value) => Number.isInteger(value),
		message: "integer",
	},
	// ,
	// {
	//     // is not less than min (1)
	//     test: value => value > 0,
	//     message: 'min'
	// }
	//  Max test not required at this time
	// ,{
	//     // is not more than max
	//     test: (value, max) => value <= max,
	//     message: `max`
	// }
];

function getMessage(messageName, context) {
	const message = validationMessages[messageName] || false;
	return context ? tmpl(message, context) : message;
}

//  Note the {max} value here is not needed
//  left as example of rendering a dynamic value into a error message
function validateQty(value, max) {
	const error = quantityTests.reduce((result, validator) => {
		return result
			? result
			: validator.test(value, max)
			? false
			: getMessage(validator.message, { max });
	}, false);

	//  Return true or error message encountered
	return error;
}

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

class AddToCartPlugin {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);

		this.codeVal = this.options.code;
		if (!this.codeVal) {
			log(
				'Product code not specified. Use data-add-to-cart-code="XXXX" Aborting.'
			);
			return false;
		}

		this.$qtyField = this.$element.find(this.options.qtyField);
		this.hasQtyField = this.$qtyField.length === 1;

		this.maxQty =
			this.hasQtyField && typeof getJSONValue(this.$qtyField.attr("max")) === 'number'
				? this.$qtyField.attr("max")
				: this.options.maxQty;

		this.$addToCartButton = this.$element.find(this.options.submitButton);
		this.productId = this.$element.attr(PRODUCT_ID_ATTR);
		this.price = this.$element.attr(PRICE_ATTR);

		this.$headerCartLink = $(this.options.cartLink);
		this.$errorElement = this.$element.find(this.options.errorElement);
		this.errorClassname = this.options.errorClassname;
		this.$productElement = this.$element.closest(
			this.options.productElementSelector
		);
		this.notificationElement = document.querySelector(
			this.options.notificationElementSelector
		);
		this.cart = document.querySelector(
			this.options.cartSelector
		);

		this.updateEventTarget = this.cart || this.notificationElement;

		this.submitFadeTimeout = undefined;

		this.posts = [];

		log("AddToCartPlugin", element);

		this.watch();
		this.quantity = 1;
	}

	getQtyInputErrors() {
		if (!this.hasQtyField) {
			return false;
		}

		// Validate entered input QTY value (not over max, is number)
		return validateQty(+this.getQty(), +this.maxQty);
	}

	onQtyInput(event) {
		//  ignore: enter, shift, alt, tab, meta key strokes (meta has multiple codes)
		const ignoreKeys = [13, 16, 18, 9, 91, 92, 93, 224];

		//  Ignore keystrokes with modifier key
		if (ignoreKeys.indexOf(event.which) !== -1) {
			return true;
		}

		const error = this.getQtyInputErrors();

		if (error) {
			this.handleErrors([error], "client");
		} else {
			this.clearErrors();
		}
	}

	onAddQtyExit() {
		const value = this.$qtyField.val().trim();

		// Clear entered 0 or whitespace from QTY input
		// if value is emptish: '', '0'
		if (value === "" || value === "0") {
			this.clearErrors();
			this.$qtyField.val("");
		}
	}

	catchEnter(event) {
		if (event.which === 13 /* enter */) {
			event.preventDefault();
			this.submit();
		}
	}

	onAjaxSubmit(event) {
		event.preventDefault();
		this.submit();
	}

	getQty() {
		if (this.hasQtyField) {
			const inputValue = this.$qtyField.val().trim();

			// if value is '' return default
			return inputValue === ''
				? this.options.qty
				: inputValue;
		}
		return this.options.qty;
	}

	submit() {
		const error = this.getQtyInputErrors();

		if (error) {
			this.handleErrors([error], "client");
			return false;
		}

		log("submitted", this.$element);
		this.$addToCartButton.removeClass(SUCCESS_CLASS);
		clearTimeout(this.submitFadeTimeout);
		this.$addToCartButton
			.addClass(PROGRESS_CLASS)
			.attr("disabled", "disabled");
		this.post();
	}

	watch() {
		log("ajax", this.options.ajax);

		this.$addToCartButton.on(
			"click.addToCart",
			this.onAjaxSubmit.bind(this)
		);

		if (this.hasQtyField) {

			//  avoid submitting containing product listing filter form
			this.$qtyField.on("keydown.addToCart", this.catchEnter.bind(this));

			this.$qtyField.on("keyup.addToCart", this.onQtyInput.bind(this));
			this.$qtyField.on("blur.addToCart", this.onAddQtyExit.bind(this));
		}
	}

	unwatch() {
		this.$element.off(".addToCart");
		this.$addToCartButton.off(".addToCart");
		this.$qtyField.off(".addToCart");

		log("unbound", this.$element);
	}

	onSuccess(result) {
		this.$addToCartButton
			.removeClass(PROGRESS_CLASS)
			.removeAttr("disabled");

		if (typeof result.Success !== "undefined" && result.Success) {
			if (typeof result.ItemsInCart !== "undefined") {
				if (this.$headerCartLink.find(".count").length == 0) {
					this.$headerCartLink.append(
						'<span class="count">' + result.ItemsInCart + "</span>"
					);
				} else {
					this.$headerCartLink
						.find(".count")
						.html(result.ItemsInCart);
				}

				this.resetForm(result.ItemsInCart);

				this.updateEventTarget.dispatchEvent(
					new CustomEvent("updateCart", {
						bubbles: false,
						detail: {
							count: result.ItemsInCart,
						},
					})
				);

				this.$addToCartButton.addClass(SUCCESS_CLASS);
				this.submitFadeTimeout = setTimeout(
					function ($addToCartButton) {
						$addToCartButton.removeClass(SUCCESS_CLASS);
					},
					8000,
					this.$addToCartButton
				);
			}
			if (result.ItemAddedDatalayer) {
				const filteredData = GAServices.filterEmptyData(result.ItemAddedDatalayer);
				const dataTracking = {
					event: 'add_to_cart',
					ecommerce: {
						currency: $('body').data('currency'),
						value: '',
						items: [],
					}
				};
				filteredData.quantity = this.quantity;
				dataTracking.ecommerce.value = (filteredData.price * this.quantity).toFixed(2);
				dataTracking.ecommerce.items.push(filteredData);
				GAServices.trackingGA(dataTracking);
			}
			if (result.KlaviyoItemAddedDatalayer && !!result.KlaviyoCarts) {
				const kFilteredData = KlaviyoServices.filterEmptyData(result.KlaviyoItemAddedDatalayer);
				const kDataTracking = {
					type: 'Add',
					currency: $('body').data('currency'),
					market_code: $('body').data('market-code'),
					quantity: this.quantity,
					value: kFilteredData.price * this.quantity,
					total_cart_value: KlaviyoServices.getTotalCartValue(result.KlaviyoCarts),
					product: kFilteredData,
					items: KlaviyoServices.sortProductsByQuantity(result.KlaviyoCarts),
					total_quantity: KlaviyoServices.getTotalQuantity(result.KlaviyoCarts),
				};
				
				KlaviyoServices.trackingKlaviyo('Added To Cart', kDataTracking);
			}
		} else {
			var errorList =
				typeof result.ValidationMessages !== "undefined"
					? result.ValidationMessages
					: Array();
			log("addToCartServerError", errorList);
			this.handleErrors(errorList, "server");
		}
	}

	handleErrors(errorList, errorSource) {
		const errorMessage = errorList.join(" ");
		const submitErrorClass =
			errorSource == "submit" ? this.options.submitErrorClassname : "";
		if (this.$errorElement.length > 0) {
			this.$errorElement
				.show()
				.find(ERROR_CONTAINER_SELECTOR)
				.empty()
				.append(errorMessage);
			this.$errorElement.removeClass(HIDE_CLASS);
			var mod = this;
			setTimeout(function () {
				mod.$errorElement.fadeOut();
			}, 6000);
		}

		this.$qtyField.addClass(`${this.errorClassname} ${submitErrorClass}`);
	}

	clearErrors() {
		this.$qtyField.removeClass(
			`${this.errorClassname} ${this.options.submitErrorClassname}`
		);
		this.$errorElement.addClass(HIDE_CLASS);
	}

	resetForm() {
		this.$qtyField.val(this.options.qty).trigger("keyup");

		// Possibly errors from server (even without quantity field)
		this.clearErrors();
	}

	getDatalayer() {
		let product = {};
		const component = this.options.component;
		if (component === 'PDP') {
			product = window.datalayerDataSource;
			product.quantity = $('[data-input-qty]').val();
			const dataItemList = GAServices.getItemListName(product.item_id);
			product = Object.assign({}, product, dataItemList);
		} else {
			let item = this.element.closest('[ga-tracking-item]');
			if (component === 'Reorder') {
				item = this.element;
			}
			product = GAServices.getAttributesWithPrefix($(item), 'ga-');
			product.quantity = 1;
		}
		let datalayer = [];
		if (Object.keys(product).length) {
			this.quantity = parseInt(product.quantity);
			GAServices.saveListItemsName(product);
			const saved = ['index', 'item_list_name', 'list_category', 'list_category2', 'list_category3'];
			datalayer = Object.fromEntries(
				Object.entries(product).filter(([key]) => saved.includes(key))
			);
		}

		return datalayer;
	}

	post() {
		// GET QTY - entered valid input value or options value
		const datalayer = this.getDatalayer();
		let url = `${this.options.endpointUrl}&${this.options.codeParam}=${this.codeVal}&${this.options.qtyParam}=${this.getQty()}`;
		if (Object.keys(datalayer).length) {
			const datalayerQuery = Object.entries(datalayer).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
			url = `${url}&${datalayerQuery}`;
		}


		var token = $(
			'#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]'
		).val();

		log("accepting", this.$element, url);
		const post = $.ajax({
			url,
			method: "post",
			contentType: 'application/json',
			data: JSON.stringify({
				__RequestVerificationToken: token,
			}),
			success: (result) => {
				this.onSuccess(result);
			},
			error: (e) => {
				log("addToCartAjaxError", e);
				this.$addToCartButton
					.removeClass(PROGRESS_CLASS)
					.removeAttr("disabled");
				this.handleErrors([validationMessages.connection], "submit");
			},
		}).done(() => {
			log("accepted", this.$element, url);
		});

		this.posts.push(post);
	}

	// called on external instance
	getPendingStatus() {
		return Promise.all(this.posts);
	}
}

AddToCartPlugin.DEFAULTS = {
	code: null,
	qty: "1",
	maxQty: 1000,
	qtyField: "",
	endpointUrl: $(`meta[name="site.addToCartApiEndpoint"]`).attr("content"),
	codeParam: "code",
	qtyParam: "qty",
	cartLink: "[data-cart-link]",
	submitButton: '[type="submit"]',
	notificationElementSelector: "[data-add-to-cart-notification]",
	errorElement: "[data-add-to-cart-error]",
	errorClassname: "error",
	submitErrorClassname: "submit-error",
	productElementSelector: ".product-teaser",
	cartSelector: "[data-update-cart]"
};

plugin("addToCart", AddToCartPlugin);

export function exec() {
	$(() => {
		log("binding");
		$(ELEMENT_SELECTOR).addToCart();

		$(document).on('product-teasers-loaded', function(){
			$(ELEMENT_SELECTOR).addToCart();
		});
		log("bound");
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/add-to-cart/index.js